import { departmentDTOSchema, } from '@instanexus/contracts';
import { z } from 'zod';
import { dataEnvelopeSchema, listEnvelopeSchema, WEB_API_PREFIX } from '../transport.js';
const listDepartmentsSchema = listEnvelopeSchema(departmentDTOSchema);
const singleDepartmentSchema = dataEnvelopeSchema(departmentDTOSchema);
export function createDepartmentsResource(transport) {
    return {
        async list(params = {}) {
            return transport.request({
                path: `${WEB_API_PREFIX}/departments`,
                schema: listDepartmentsSchema,
                query: { page: params.page, pageSize: params.pageSize, sort: params.sort },
            });
        },
        async create(input) {
            const envelope = await transport.request({
                method: 'POST',
                path: `${WEB_API_PREFIX}/departments`,
                schema: singleDepartmentSchema,
                body: input,
            });
            return envelope.data;
        },
        async update(id, input) {
            const envelope = await transport.request({
                method: 'PATCH',
                path: `${WEB_API_PREFIX}/departments/${encodeURIComponent(id)}`,
                schema: singleDepartmentSchema,
                body: input,
            });
            return envelope.data;
        },
        async remove(id) {
            await transport.request({
                method: 'DELETE',
                path: `${WEB_API_PREFIX}/departments/${encodeURIComponent(id)}`,
                schema: z.undefined(),
            });
        },
    };
}
//# sourceMappingURL=departments.js.map